import type { AxisTriplet } from '../../../lib/skeleton/boneTransforms';

export const ZERO_AXIS_TRIPLET: AxisTriplet = [0, 0, 0];

export function axisValueDiffersFromBaseline(
  value: number,
  baselineValue: number,
  changeEpsilon = 5e-4,
): boolean {
  return Math.abs(value - baselineValue) > changeEpsilon;
}

export function axisTripletDiffersFromBaseline(
  values: AxisTriplet,
  baselineValues: AxisTriplet,
  changeEpsilon = 5e-4,
): boolean {
  return values.some((value, axisIndex) =>
    axisValueDiffersFromBaseline(
      value,
      baselineValues[axisIndex],
      changeEpsilon,
    ),
  );
}
